// Tokens used for DI
export class Environment {
}
export class ConfigurationProperties {
    has(key) {
        throw new Error("ConfigurationProperties abstract class can't be used as-is. It is meant to be used as dependency injection token");
    }
    get(key, defaultValue) {
        throw new Error("ConfigurationProperties abstract class can't be used as-is. It is meant to be used as dependency injection token");
    }
    getOrThrow(key, error) {
        throw new Error("ConfigurationProperties abstract class can't be used as-is. It is meant to be used as dependency injection token");
    }
}
export class ZetaPushContext {
    getAppName() {
        throw new Error("ZetaPushContext abstract class can't be used as-is. It is meant to be used as dependency injection token");
    }
    getPlatformUrl() {
        throw new Error("ZetaPushContext abstract class can't be used as-is. It is meant to be used as dependency injection token");
    }
    getFrontUrl(name) {
        throw new Error("ZetaPushContext abstract class can't be used as-is. It is meant to be used as dependency injection token");
    }
    getWorkerUrl(name, zetapushInternalServer) {
        throw new Error("ZetaPushContext abstract class can't be used as-is. It is meant to be used as dependency injection token");
    }
    getLocalZetaPushHttpPort() {
        throw new Error("ZetaPushContext abstract class can't be used as-is. It is meant to be used as dependency injection token");
    }
}
